<template>
  <header class="header">
    <div class="header__body">
      <global-header-title-logo
        :restaurant-id="restaurantId"
        class="header__logo"
      />
      <global-header-links
        :links="links"
        class="header__links"/>
    </div>
  </header>
</template>

<script>
import { VTRestaurantId } from '@/mikan/_shared/types/vueTypes/restaurant';
import { globalHeaderLinks } from '@/mikan/_shared/types/vueTypes/globalHeaderLink';
import GlobalHeaderTitleLogo from '@/mikan/_shared/components/molecules/GlobalHeaderTitleLogo.vue';
import GlobalHeaderLinks from '@/mikan/_shared/components/molecules/GlobalHeaderLinks.vue';

export default {
  components: {
    GlobalHeaderTitleLogo,
    GlobalHeaderLinks,
  },
  props: {
    links: globalHeaderLinks.def(() => []),
    restaurantId: VTRestaurantId.def(''),
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.header {
  background-image: $gradient-orange;

  &__body {
    position: relative;
    display: flex;
    width: $full-width;
    height: 52px;
    align-items: center;
    justify-content: space-between;
    padding: 0 $global-gutter 4px;
    margin: 0 auto;
  }

  &__logo {
    flex-shrink: 0;
    margin-top: 8px;
  }

  &__links {
    flex-shrink: 0;
  }
}
</style>
